import React from 'react';

const AlertIcon = () => (
  <div className="AlertIcon">
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <polygon id="path-1" points="0 0.1312 16.75 0.1312 16.75 14 0 14" />
      </defs>
      <g id="Cart-States" fill="none" fillRule="evenodd" transform="translate(-3204 -305)">
        <g id="Page-1" transform="translate(3204 304)">
          <g id="Group-3" transform="translate(0 .87)">
            <mask id="mask-2" fill="#fff">
              <use xlinkHref="#path-1" />
            </mask>
            <path
              d="M1.8146,12.6982 L14.9356,12.6982 L8.3756,2.0242 L1.8146,12.6982 Z M16.0996,14.0002 L0.6506,14.0002 C0.4156,14.0002 0.1976,13.8732 0.0826,13.6672 C-0.0324,13.4612 -0.0274,13.2092 0.0966,13.0092 L7.8206,0.4402 C7.9396,0.2482 8.1486,0.1312 8.3756,0.1312 C8.6016,0.1312 8.8116,0.2482 8.9296,0.4402 L16.6536,13.0092 C16.7766,13.2092 16.7826,13.4612 16.6676,13.6672 C16.5526,13.8732 16.3356,14.0002 16.0996,14.0002 Z"
              id="Fill-1"
              fill="#010101"
              mask="url(#mask-2)"
            />
          </g>
          <path
            d="M8.3751,10.0068 C8.0161,10.0068 7.7241,9.7158 7.7241,9.3568 L7.7241,6.1878 C7.7241,5.8278 8.0161,5.5358 8.3751,5.5358 C8.7341,5.5358 9.0261,5.8278 9.0261,6.1878 L9.0261,9.3568 C9.0261,9.7158 8.7341,10.0068 8.3751,10.0068"
            id="Fill-4"
            fill="#010101"
          />
          <path
            d="M9.2003,11.5586 C9.2003,12.0136 8.8303,12.3836 8.3753,12.3836 C7.9193,12.3836 7.5503,12.0136 7.5503,11.5586 C7.5503,11.1026 7.9193,10.7336 8.3753,10.7336 C8.8303,10.7336 9.2003,11.1026 9.2003,11.5586"
            id="Fill-6"
            fill="#010101"
          />
        </g>
      </g>
    </svg>

    <style jsx>
      {`
        .AlertIcon {
          display: inline-block;
          height: 14px;
        }
      `}
    </style>
  </div>
);

export default AlertIcon;
